import { ref } from '@vue/composition-api'

// NOTE: setup 内で currentXXX が使えるように。
// 以前は localStorage を毎回 JSON.parse する computed だったが、localStorage は
// reactive ではないため書き込み後も再評価されず、保存後にフルリロードする運用に
// なっていた。リアクティブな singleton ref に切り替えることで、setter 経由の
// 更新が全 caller に自動伝播する。

const parseStored = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key)

    return raw ? JSON.parse(raw) : fallback
  } catch (_) {
    return fallback
  }
}

const currentUser = ref(parseStored('currentUser', {}))
const currentClub = ref(parseStored('currentClub', {}))
const userAbilities = ref(parseStored('userAbilities', []))

export const setCurrentUser = user => {
  currentUser.value = user || {}
  localStorage.setItem('currentUser', JSON.stringify(user || {}))
}

export const setCurrentClub = club => {
  currentClub.value = club || {}
  localStorage.setItem('currentClub', JSON.stringify(club || {}))
}

export const setUserAbilities = abilities => {
  userAbilities.value = abilities || []
  localStorage.setItem('userAbilities', JSON.stringify(abilities || []))
}

export default () => ({
  currentUser,
  currentClub,
  userAbilities,
})
